import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import Button from "../components/Button";
import { useUserContext, useUserDispatchContext } from "../context/User";
import { googleSignIn } from "../services/api";
import { signIn } from "../services/api";
import { getCloseCircleIcon, getTTIcon, getTTLogo } from "../services/icons";
import { authRedirectKey, getFromStorage, removeFromStorage } from "../services/storage";

export default function Login() {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const { user } = useUserContext();
  const userDispatch = useUserDispatchContext();

  useEffect(() => {
    if (user.accessToken) {
      navigate("/");
      return;
    }
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    /* global google */
    if (window.google) {
      google.accounts.id.initialize({
        client_id: process.env.GOOGLE_CLIENT_ID,
        callback: async (googleRes) => {
          const res = await googleSignIn(googleRes);
          if (res.accessToken) {
            const payload = {
              accessToken: res.accessToken,
              profile: { ...res.profile },
            };
            userDispatch({
              type: "set-data",
              payload,
            });

            checkRedirectAndNavigate();
          }
        },
      });

      google.accounts.id.renderButton(document.getElementById("signUpDiv"), {
        // type: "standard",
        theme: "filled_black",
        // size: "small",
        text: "continue_with",
        shape: "pill",
      });

      google.accounts.id.prompt();
    }
  }, []);

  const onSubmitForm = () => {
    if (email.length <= 1 || password.length <= 1) {
      return;
    }

    try {
      setLoading(true);
      setError("");
      void signIn(email, password)
        .then((d) => {
          console.log("DATA", d);
          if (d.error) {
            setError(d.error);
          }
          if (d.accessToken) {
            const payload = {
              accessToken: d.accessToken,
              profile: { ...d.profile },
            };
            userDispatch({
              type: "set-data",
              payload,
            });

            checkRedirectAndNavigate();
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const checkRedirectAndNavigate = () => {
    const redirectUrl = getFromStorage(authRedirectKey);
    if (redirectUrl) {
      removeFromStorage(authRedirectKey);
      return navigate(redirectUrl);
    }
    return navigate("/");
  };

  return (
    <>
      <div className="flex w-full justify-end p-5 lg:p-10">
        <Link to={"/"}>{getCloseCircleIcon()}</Link>
      </div>
      <div className="container mx-auto">
        <div className="flex flex-col items-center gap-6 p-5 lg:gap-12">
          {getTTIcon()}
          {getTTLogo("#ffffff", "202px", "100%")}
          <div className="font-simianregular text-[32px]">Sign In</div>
          <div className="flex flex-col gap-16 lg:w-[500px]">
            <input
              type="text"
              className="w-full border-b-[1px] border-white bg-transparent px-3 pb-1 text-[32px] outline-0"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              type="password"
              className="w-full border-b-[1px] border-white bg-transparent px-3 pb-1 text-[32px] outline-0"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Button
              title="Sing In"
              onClick={onSubmitForm}
              textClasses="text-[32px]"
              buttonClasses="py-8"
              disabled={loading}
            />
          </div>
          {error && <div className="text-red-500">{error}</div>}
          <div className="mt-8 text-center font-simianregular">
            <div className="mb-5 text-[32px]">
              Doesn’t your dog shelter have a Tailtales account?
            </div>
            <div className="inline-block border-b-[1px] border-[#FFB55E] pb-1 text-[24px] text-[#FFB55E]">
              Register for one now
            </div>
          </div>
          <div>
            <div id="signUpDiv" data-text="signup_with"></div>
          </div>
        </div>
      </div>
    </>
  );
}
